import { Components, Theme } from '@mui/material/styles';

export const muiGridOverride: Components<Theme>['MuiGrid'] = {
  defaultProps: {
    spacing: {
      xs: 4,
      md: 8,
      lg: 8,
      xl: 12,
    },
  },
};
